/**
 * File → data URL helper. Limit matches the backend's MAX_LOGO_BYTES so a
 * server-side rejection isn't the user's first feedback.
 */

export const MAX_LOGO_BYTES = 256 * 1024;
export const ALLOWED_LOGO_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
];

export async function fileToDataUrl(file: File): Promise<string> {
  if (!ALLOWED_LOGO_TYPES.includes(file.type)) {
    throw new Error(`unsupported image type: ${file.type}`);
  }
  if (file.size > MAX_LOGO_BYTES) {
    throw new Error(`logo too large (max ${Math.round(MAX_LOGO_BYTES / 1024)} KB)`);
  }
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('failed to read file'));
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('reader returned non-string'));
        return;
      }
      resolve(result);
    };
    reader.readAsDataURL(file);
  });
}
